export default __webpack_public_path__ + "static/media/DHome.1b6a43f8.svg";